import type { PresentationVersion } from '../protocol'
import type { Summary, TrialRecord } from '../runner'

/**
 * A presentation LISTENS. It receives what the runner decided and draws it;
 * it returns nothing the runner reads. `points` is presentation feedback and is
 * computed from an RT the runner already measured.
 */
export interface Presentation {
  readonly version: PresentationVersion
  mount(root: HTMLElement): void
  onArmed(trial: TrialRecord, remainingMs: number): void
  onLit(trial: TrialRecord): void
  onTrialEnd(trial: TrialRecord): void
  onTick(elapsedMs: number, durationMs: number, signalIndex: number): void
  onEnded(summary: Summary): void
  onInterrupted(reason: string, elapsedMs: number): void
  unmount(): void
}

export const fmtClock = (ms: number) => {
  const s = Math.max(0, Math.ceil(ms / 1000))
  return `${Math.floor(s / 60)}:${String(s % 60).padStart(2, '0')}`
}
